import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<Actions.REJECT_CONTRACT_ASYNC, Actions.REJECT_CONTRACT_SUCCESS, Actions.REJECT_CONTRACT_FAIL>,
): State => {
  switch (action.type) {
    case Actions.REJECT_CONTRACT_ASYNC:
    case Actions.REJECT_CONTRACT_SUCCESS:
    case Actions.REJECT_CONTRACT_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
